import axios from 'axios';
import { SAVE_APPLY_LIST, DELETE_APPLY_LIST, SAVE_APPLY_CANCEL_LIST, DELETE_APPLY_CANCEL_LIST, GET_WELCOME_LIST } from './types';

export async function saveApplyList(formData) {

    return {
        type: SAVE_APPLY_LIST,
        payload: formData
    }
}

export async function saveApplyCancelList(formData) {
    return {
        type: SAVE_APPLY_CANCEL_LIST,
        payload: formData
    }
}

export async function deleteApplyList(formData) {

    return {
        type: DELETE_APPLY_LIST,
        payload: formData
    }
}

export async function deleteApplyCancelList(formData) {

    return {
        type: DELETE_APPLY_CANCEL_LIST,
        payload: formData
    }
}

export async function getWelcome(formData) {

    return {
        type: GET_WELCOME_LIST,
        payload: formData
    }
}